import { Plus, LogOut, Settings } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

const Header = ({ totalCount, filteredCount, onAddClick, onSettingsClick }) => {
  const { user, logout, isAdmin } = useAuth();

  return (
    <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-lg border-b border-slate-100" data-testid="header">
      <div className="px-4 md:px-8 lg:px-12 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2">
              <img 
                src="/arcobi-logo.png" 
                alt="Arcobi" 
                className="h-10 object-contain"
              />
              <div>
                <h1 className="text-xl font-bold text-slate-900 font-['Manrope']" data-testid="header-title">
                  Arcobi
                </h1>
                <p className="text-sm text-slate-500">Internal Use Case Library</p>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <div className="hidden sm:block text-sm text-slate-500" data-testid="results-count">
              Showing <span className="font-semibold text-slate-700">{filteredCount}</span> of{" "}
              <span className="font-semibold text-slate-700">{totalCount}</span>
            </div>
            {isAdmin && (
              <>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={onSettingsClick}
                  className="text-slate-500 hover:text-[#FF6F40] hover:bg-[#FFF1EC]"
                  title="Admin settings"
                  data-testid="admin-settings-btn"
                >
                  <Settings className="w-5 h-5" />
                </Button>
                <Button 
                  onClick={onAddClick}
                  className="bg-[#FF6F40] hover:bg-[#E65A2C] text-white font-semibold rounded-lg px-4 py-2 transition-all shadow-sm hover:shadow-md"
                  data-testid="add-usecase-btn"
                >
                  <Plus className="w-4 h-4 mr-2" />
                  Add Use Case
                </Button>
              </>
            )}
            
            {/* User menu */}
            <div className="flex items-center gap-3 pl-3 border-l border-slate-200">
              <div className="hidden md:flex flex-col items-end">
                <span className="text-sm text-slate-600 truncate max-w-[180px]">
                  {user?.username}
                </span>
                {!isAdmin && (
                  <span className="text-xs text-slate-400 uppercase tracking-wide font-medium" data-testid="viewer-badge">
                    View Only
                  </span>
                )}
              </div>
              <Button
                variant="ghost"
                size="icon"
                onClick={logout}
                className="text-slate-500 hover:text-red-600 hover:bg-red-50"
                title="Sign out"
                data-testid="logout-btn"
              >
                <LogOut className="w-5 h-5" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
